module.exports = __webpack_public_path__ + "static/media/swish-logo.2fdcd402.svg";